import Cookie from 'js-cookie'

const LEGACY_TOKEN_KEY = 'token'
const USER_TOKEN_KEY = 'roc-user-token'
const ADMIN_TOKEN_KEY = 'roc-admin-token'
const USER_KEY = 'roc-auth-user'
const ADMIN_USER_KEY = 'roc-admin-auth-user'
const ROLE_KEY = 'roc-auth-role'

export function getUserToken() {
  return Cookie.get(USER_TOKEN_KEY) || (localStorage.getItem(ROLE_KEY) !== 'admin' ? Cookie.get(LEGACY_TOKEN_KEY) : undefined)
}

export function setUserToken(token) {
  Cookie.set(USER_TOKEN_KEY, token, { expires: 7 })
}

export function clearUserToken() {
  Cookie.remove(USER_TOKEN_KEY)
  if (localStorage.getItem(ROLE_KEY) !== 'admin') {
    Cookie.remove(LEGACY_TOKEN_KEY)
  }
}

export function getAdminToken() {
  return Cookie.get(ADMIN_TOKEN_KEY) || (localStorage.getItem(ROLE_KEY) === 'admin' ? Cookie.get(LEGACY_TOKEN_KEY) : undefined)
}

export function setAdminToken(token) {
  Cookie.set(ADMIN_TOKEN_KEY, token, { expires: 7 })
}

export function clearAdminToken() {
  Cookie.remove(ADMIN_TOKEN_KEY)
  if (localStorage.getItem(ROLE_KEY) === 'admin') {
    Cookie.remove(LEGACY_TOKEN_KEY)
  }
}

// Kept for existing user-side callers. New admin callers use the dedicated APIs.
export function getToken() {
  return getUserToken()
}

export function setToken(token) {
  setUserToken(token)
}

export function clearToken() {
  clearUserToken()
}

export function getAuthUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    localStorage.removeItem(USER_KEY)
    return null
  }
}

export function setAuthUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearAuthUser() {
  localStorage.removeItem(USER_KEY)
}

export function getAdminAuthUser() {
  const raw = localStorage.getItem(ADMIN_USER_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch (error) {
    localStorage.removeItem(ADMIN_USER_KEY)
    return null
  }
}

export function setAdminAuthUser(user) {
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(user))
}

export function clearAdminAuthUser() {
  localStorage.removeItem(ADMIN_USER_KEY)
}

export function getAuthRole() {
  if (getUserToken()) return 'user'
  if (getAdminToken()) return 'admin'
  return localStorage.getItem(ROLE_KEY) || 'user'
}

export function setAuthRole(role) {
  localStorage.setItem(ROLE_KEY, role || 'user')
}

export function clearAuthRole() {
  localStorage.removeItem(ROLE_KEY)
}

export function isLoggedIn() {
  return Boolean(getUserToken())
}

export function logout() {
  clearUserToken()
  clearAuthUser()
  clearAuthRole()
}

export function logoutAdmin() {
  clearAdminToken()
  clearAdminAuthUser()
}
